<template>
  <evaluate-container
    :list="questions"
    :answers="answers"
    :all="all"
    :tree="tree"
    :is-view="isView"
    :role="role"
    :info="info"
    :find-answer="findAnswer"
    :node-click="handleNodeClick"
  >
    <template
      v-slot:default="{
        list,
        current,
        currentForm,
        currentIndex,
        indexChange,
        down,
      }"
    >
      <el-form ref="form" :model="currentForm">
        <h2>
          {{ current.name }}
          <el-popover
            v-if="current.remark"
            placement="right"
            title="说明"
            width="250"
            trigger="click"
          >
            <p class="text-red-500 text-xs mb-5">请按示例准备佐证材料</p>
            <a
              :href="`/buckets/WENJUAN/${current.remark}`"
              target="_blank"
              class="text-blue-400 text-xs"
              >查看示例</a
            >
            <i slot="reference" class="el-icon-question cursor-pointer"></i>
          </el-popover>
        </h2>
        <p class="text-red-600 text-xs">
          在满足低等级且上传证明材料后，才可以继续选择下一级别。
        </p>
        <div class="space-y-5">
          <div
            class="flex items-center space-x-5 max-w-md lg:max-w-xl xl:max-w-4xl 2xl:max-w-6xl"
            v-for="(item, index) in current.children"
            :key="`${currentForm.quesId}-${index}`"
          >
            <el-checkbox
              :disabled="
                index > 0 &&
                currentForm.ans.length <= index &&
                currentForm.fileIds[index - 1].length === 0
              "
              :value="currentForm.ans.length > index"
              @change="
                (val) => handleCheckChange(currentForm, item, val, index)
              "
            ></el-checkbox>
            <el-card>
              <div class="flex justify-between space-x-2">
                <span
                  class="bg-blue-300 rounded text-xs p-2 flex-none self-start"
                  >{{ ["一", "二", "三", "四"][index] }}级</span
                >
                <p class="w-screen">{{ item.name }}</p>
                <div class="w-96">
                  <h2>
                    佐证材料
                    <el-popover
                      v-if="item.userName"
                      placement="right"
                      title="说明"
                      width="250"
                      trigger="click"
                    >
                      <div
                        class="text-red-500 text-xs mb-5"
                        v-html="item.userName"
                      ></div>
                      <i
                        slot="reference"
                        class="el-icon-question cursor-pointer"
                      ></i>
                    </el-popover>
                  </h2>
                  <div
                    v-for="(file, i) in currentForm.fileIds[index]"
                    :key="i"
                    class="flex space-x-2"
                  >
                    <el-button
                      type="text"
                      plain
                      @click="down(file)"
                      title="点击下载"
                      >{{ `${i + 1}:${file.name}` }}</el-button
                    >
                    <el-button
                      type="text"
                      plain
                      @click="
                        currentForm.fileIds[index].splice(i, 1) &&
                          (currentForm.saved = false)
                      "
                      >移除</el-button
                    >
                  </div>
                  <el-form-item
                    prop="fileIds"
                    :rules="{
                      validator: (rule, value, cb) => {
                        currentForm.ans.length > index
                          ? currentForm.fileIds[index].length > 0
                            ? cb()
                            : cb(makeError('佐证材料不能为空'))
                          : cb();
                      },
                    }"
                  >
                    <el-upload
                      :headers="headers"
                      class="uploader"
                      action="/dev/minio"
                      :before-upload="beforeUpload"
                      :on-success="
                        (res, file, fileList) =>
                          handleSuccess(res, file, fileList, currentForm, index)
                      "
                      :on-error="handleError"
                      :show-file-list="false"
                      :disabled="currentForm.ans.length <= index"
                    >
                      <el-button size="small" type="primary"
                        >点击上传</el-button
                      >
                    </el-upload>
                    <p class="text-xs text-red-400 w-48">
                      (支持word、excel、ppt、pdf、jpg格式,上传文件最大限制10MB)
                    </p>
                  </el-form-item>
                </div>
              </div>
            </el-card>
          </div>
        </div>
        <div>
          <el-form-item prop="fileIds">
            <el-button
              :disabled="currentIndex === 0"
              @click="indexChange(currentIndex - 1)"
              >回到上一题</el-button
            >
            <el-button
              v-if="!isView"
              @click="handleSave(currentForm)"
              :disabled="currentForm.saved"
              >保存</el-button
            >
            <el-button
              :disabled="currentIndex + 1 === list.length"
              @click="indexChange(currentIndex + 1)"
              >进入下一题</el-button
            >
            <el-button
              v-if="currentIndex + 1 === questions.length"
              @click="handleChangeType"
              >查看进度</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </template>
    <template v-slot:drawer="{ pivots, current, down }">
      <div class="w-full h-full flex flex-col">
        <el-collapse class="flex-1" :value="pivots.length">
          <el-collapse-item
            v-for="(pivot, index) in pivots"
            :key="index"
            :title="`第${index + 1}轮评审`"
            :name="index + 1"
          >
            <el-form label-position="top">
              <el-form-item label="当前等级">
                <span>{{ JSON.parse(pivot.ans).length }}级</span>
              </el-form-item>
              <el-form-item label="佐证材料">
                <div
                  v-for="(file, index) in JSON.parse(pivot.fileIds).reduce(
                    (a, v) => a.concat(v),
                    []
                  )"
                  :key="index"
                  class="space-x-2"
                >
                  <el-button
                    type="text"
                    plain
                    @click="down(file)"
                    title="点击下载"
                    >{{ `${index + 1}:${file.name}` }}</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
            <el-descriptions v-if="pivot.pivot" title="评审结果">
              <el-descriptions-item label="专家意见">
                <span v-if="pivot.pivot.status === 0">{{
                  pivot.pivot.remark
                }}</span>
                <span v-else class="text-green-400">通过</span>
              </el-descriptions-item>
              <template v-if="role !== 'enterprise'">
                <el-descriptions-item label="备忘录"
                  ><span>{{ pivot.pivot.txt }}</span></el-descriptions-item
                >
                <el-descriptions-item label="交接说明"
                  ><span>{{ pivot.pivot.nextTxt }}</span></el-descriptions-item
                >
              </template>
            </el-descriptions>
          </el-collapse-item>
        </el-collapse>
        <el-form v-if="mode === 'edit'" inline size="mini">
          <el-form-item>
            <el-button type="primary" @click="handlePivotPass(pivots, current)"
              >通过</el-button
            >
            <el-popover
              placement="top"
              width="400"
              trigger="click"
              @show="handlePivotShow(pivots, current)"
            >
              <el-form
                ref="pivot"
                size="mini"
                :model="pivotForm"
                :rules="rules"
              >
                <el-form-item label="意见" prop="remark">
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="pivotForm.remark"
                  />
                </el-form-item>
                <el-form-item label="备忘录" prop="txt">
                  <el-input type="textarea" :rows="3" v-model="pivotForm.txt" />
                </el-form-item>
                <el-form-item label="交接说明" prop="nextTxt">
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="pivotForm.nextTxt"
                  />
                </el-form-item>
                <el-form-item>
                  <el-button @click="handlePivotDeny">保存</el-button>
                </el-form-item>
              </el-form>
              <el-button type="danger" slot="reference">拒绝</el-button>
            </el-popover>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </evaluate-container>
</template>

<script>
import EvaluateContainer from "@/views/proposal/partials/EvaluateContainer";
import { addPivot, addSceneAnswer as addAnswer } from "@/api/enterprise";
import store from "../../../store";

export default {
  props: [
    "info",
    "questions",
    "answers",
    "all",
    "tree",
    "isView",
    "role",
    "mode",
  ],
  components: { EvaluateContainer },
  data() {
    return {
      rules: {
        fileIds: {
          validator: (rule, value, cb) => {},
        },
        remark: {
          required: true,
          message: "谰审意见不能为空",
          trigger: "blur",
        },
      },
      pivotForm: {},
      headers: { Authorization: "Bearer " + store.getters.token },
    };
  },
  mounted() {
    if (!this.info.id && !this.answers.length) {
      this.$confirm(
        "企业可自行选择所涉及的数字化场景，不涉及的可跳过不填。完成填报后可提交问卷！",
        "提示",
        {
          confirmButtonText: "确定",
          showCancelButton: false,
        }
      )
        .then(() => {})
        .catch(() => {});
    }
  },
  methods: {
    makeError(msg) {
      return new Error(msg);
    },
    findAnswer(v) {
      const item = this.answers.find((a) => a.quesId * 1 === v.id * 1) || {
        quesId: v.id * 1,
        ans: "[]",
        fileIds: "[[],[],[],[]]",
        version: 1,
        otherAns: "{}",
      };
      return Object.assign({}, item, {
        ans: JSON.parse(item.ans),
        otherAns: JSON.parse(item.otherAns),
        fileIds: JSON.parse(item.fileIds),
      });
    },
    // handleUpload(fn, currentForm, index) {
    //   fn().then((data) => {
    //     currentForm.fileIds[index].push(data);
    //     currentForm.saved = false;
    //   });
    // },
    //上传前校验
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("上传文件大小不能超过 10MB!");
        return false;
      }
      return true;
    },
    handleSuccess(response, file, fileList, currentForm, index) {
      currentForm.fileIds[index].push(response.data);
      currentForm.saved = false;
    },
    handleError(err, file) {
      this.$message.error(err);
    },
    handleSave(currentForm) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = {
            quesId: currentForm.quesId,
            ans: JSON.stringify(currentForm.ans),
            otherAns: JSON.stringify(currentForm.otherAns),
            fileIds: JSON.stringify(currentForm.fileIds),
            userId: this.info.userId,
            version: 1,
          };
          addAnswer(data).then((res) => {
            this.$set(currentForm, "id", res.data.id);
            currentForm.saved = true;
            this.$message.success("保存成功！");
            this.$emit("save", res.data);
          });
        }
      });
    },
    handleCheckChange(currentForm, item, val, index) {
      if (val) {
        currentForm.ans.push(item.id);
      } else {
        currentForm.ans.splice(index, currentForm.ans.length);
      }

      currentForm.saved = false;
    },
    handleNodeClick(node) {
      if (node.level === 2) {
        return this.questions.findIndex((v) => v.id === node.id);
      } else return -1;
    },
    handleChangeType() {
      this.$emit("change-type", "");
    },
    handlePivotPass(pivots, current) {
      const item = pivots.find(
        (p) => p.pivot && p.pivot.version === this.info.version
      );
      (item && item.status === 0
        ? this.$confirm(
            "已有专家评审意见，是否丢弃该意见，改为通过评审?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
        : Promise.resolve()
      ).then(() => {
        addPivot({
          quesId: current.id * 1,
          type: 1,
          userId: this.info.userId,
          status: 1,
          remark: "",
          txt: "",
          nextTxt: "",
        }).then(() => {
          this.$message.success("操作成功");
          this.$emit("pivot", { info: this.info });
        });
      });
    },
    handlePivotShow(pivots, current) {
      const item = pivots.find(
        (p) => p.pivot && p.pivot.version === this.info.version
      );
      if (item) {
        this.pivotForm = {
          quesId: item.pivot.quesId,
          type: item.pivot.type,
          userId: item.pivot.userId,
          status: item.pivot.status,
          remark: item.pivot.remark,
          txt: item.pivot.txt,
          nextTxt: item.nextTxt,
        };
      } else {
        this.pivotForm = {
          quesId: current.id * 1,
          type: 1,
          userId: this.info.userId,
          status: 0,
          remark: "",
          txt: "",
          nextTxt: "",
        };
      }
    },
    handlePivotDeny() {
      this.$refs.pivot.validate((valid) => {
        if (valid) {
          addPivot(this.pivotForm).then(() => {
            this.$message.success("操作成功");
            this.$emit("pivot", { info: this.info });
          });
        }
      });
    },
  },
};
</script>
